// ═══════════════════════════════════════════════════════════════
// DASHBOARD VIEW
// Path: src/views/DashboardView.jsx
//
// CRM home screen. Thin orchestrator — all content lives in
// independent widget components under components/dashboard/.
//
// Zone Framework compliant.
// ═══════════════════════════════════════════════════════════════

import React, { useState } from "react";
import {
  LayoutDashboard,
} from "lucide-react";
import { useApp } from "../context/AppContext";
import { ViewLayout } from "../components/ui/ViewLayout";
import {
  ZoneOneHeader,
  ZoneThreeFooter,
} from "../components/zones/ZoneHeaderFooter";
import { ZoneTwoToolbar } from "../components/zones/ZoneTwoToolbar";
import { GivingSnapshot } from "../components/dashboard/GivingSnapshot";
import { PollenGrid } from "../components/dashboard/pollen/PollenGrid";
import { MyDaySidebar } from "../components/dashboard/MyDaySidebar";
import { CultivationQueueDrawer } from "../components/cultivation/CultivationQueueDrawer";
import { HELP } from "../constants/helpContent";

export const DashboardView = () => {
  const { chapterName, navigate, cultivationQueue } = useApp();
  const [showQueue, setShowQueue] = useState(false);

  return (
    <ViewLayout>
      <ZoneOneHeader
        title="ClearView Philanthropy CRM"
        subtitle={chapterName}
        icon={LayoutDashboard}
        onHome={() => navigate("main")}
        helpContent={HELP.dashboard}
      />
      <ZoneTwoToolbar />

      <div
        style={{
          flex: 1,
          display: "flex",
          overflow: "hidden",
        }}
      >
        {/* Left sidebar — sticky, stays visible as the main content scrolls */}
        <MyDaySidebar />

        {/* Main content area — scrolls independently */}
        <div
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "16px 20px",
            display: "flex",
            flexDirection: "column",
            gap: 16,
            minWidth: 0,
          }}
        >
          {/* Row 1: KPI tiles */}
          <GivingSnapshot />

          {/* Row 2: Pollen View — configurable card grid */}
          <PollenGrid />
        </div>
      </div>

      <ZoneThreeFooter />
      <CultivationQueueDrawer isOpen={showQueue} onClose={() => setShowQueue(false)} />
    </ViewLayout>
  );
};
